
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Button, CircularProgress } from '@mui/material';
import { ModalAlertDiv } from '../../../components/modal/style';
import { ModalAlert } from '../index.jsx';

const ModalDelete = ({ type, showDelete, alert, setShowDelete, setAlert, confirmDelete }) => {
  return (
    <ModalAlert showModal={showDelete} onClose={() => {
      setShowDelete(!showDelete)
      setAlert({})
    }}>
      <ModalAlertDiv>

        {alert.status === 'ok' &&
          <>
            <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
            <h1>Success!</h1>
            <p style={{ textTransform: 'capitalize' }}>{type} successfully deleted</p>
            <div>
              <Button onClick={() => {
                setShowDelete(false)
                setAlert({})
              }} variant="contained">Ok</Button>
            </div>
          </>}

        {alert.status === 'ko' &&
          <>
            <h1>Error!</h1>
            <p>{alert.msg}</p>
            <Button onClick={() => {
              setShowDelete(false)
              setAlert({})
            }} variant="contained" color='warning'>Ok</Button>
          </>}

        {alert.status === undefined &&
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Deleting {type}...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>}

        {alert.status === 'go' &&
          <>
            <h1>Are you sure?</h1>
            <p>Are you sure that you want to delete this {type}?</p>
            <div>
              <Button sx={{ marginRight: '1rem' }} onClick={() => {
                setShowDelete(false)
                setAlert({})
              }} variant="contained" color='error'>Cancel</Button>

              <Button onClick={() => {
                confirmDelete()
                setAlert({})
              }} variant="contained">Yes</Button>
            </div>
          </>
        }
      </ModalAlertDiv>
    </ModalAlert>
  );
}

export default ModalDelete;


const customStyles = {
  margin: '3rem auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
  borderRadius: '5px',
  maxHeight: "90%",
  width: 'max-content',
}

const customStylesAlert = {
  position: 'absolute',
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
  transform: "translate(-50%, -50%)",
  height: "40%",
  minWidth: '20%',
  maxWidth: "50%",
  backgroundColor: '#FFF',
  p: 4
}
